import cx from 'classnames'
import { pathOr } from 'ramda'
import React from 'react'

import { MAX_SCORE } from '../../constants/constants'
import { useAppDispatch, useAppSelector } from '../../hooks'
import modalsSlice from '../../reducers/modalsSlice'
import {
  selectCurrentActiveGamers,
  selectCurrentTrackInfo,
} from '../../selectors/current-play-selectors'
import { selectMatchStatus } from '../../selectors/match-selectors'
import { selectCurrentMatchSlug, selectCurrentUsername } from '../../selectors/session-selectors'
import { isMobile as getIsMobile } from '../../util/track-utils'
import MovingLaneScore from '../social/MovingLaneScore'

const ScoreLanes = () => {
  const dispatch = useAppDispatch()
  const isMobile = getIsMobile()
  const trackInfo = useAppSelector(selectCurrentTrackInfo)
  const { duration } = trackInfo
  const currentUsername = useAppSelector(selectCurrentUsername)
  const currentMatchSlug = useAppSelector(selectCurrentMatchSlug)
  const [matchOwner, matchSlug] = currentMatchSlug.split('/')
  const activeGamers = useAppSelector(selectCurrentActiveGamers)
  const { players } = useAppSelector(selectMatchStatus(matchOwner, matchSlug))

  const trackPointInfo = () => {
    const pointsStr = duration > 0 ? MAX_SCORE : '-'
    const onOpenGameOverModal = () => {
      dispatch(modalsSlice.actions.toggleMatchupInfo(true))
    }
    return (
      <div className="trackInfo" onClick={onOpenGameOverModal}>
        <div className="score">
          <div className="points">{pointsStr}</div>
        </div>
      </div>
    )
  }
  const getLane = (pos: number) => {
    if (pos >= activeGamers.length) {
      return
    }
    return <MovingLaneScore playerIndex={pos} />
  }
  const lanesClassName = cx('lanes', { single: activeGamers.length === 1 })
  return (
    <div className="body">
      <div className="scoreStuff">
        {!isMobile && (
          <div className="players">
            {activeGamers.map(({ gamerId }, index) => {
              const playerName = pathOr(gamerId, [currentUsername, gamerId, 'name'], players)
              return (
                <div key={index} className="title" title={gamerId}>
                  <div className="title-bg">{playerName}</div>
                </div>
              )
            })}
          </div>
        )}
        <div className={lanesClassName}>
          {getLane(0)}
          <div className="divider">
            <div className="padLeft"></div>
            <div className="scale">
              <div className="bad"></div>
              <div className="good"></div>
              <div className="excellent"></div>
              <div className="perfect"></div>
            </div>
            <div className="padRight"></div>
          </div>
          {getLane(1)}
        </div>
        {trackPointInfo()}
      </div>
    </div>
  )
}

export default ScoreLanes
